import { AxiosInstance } from "axios";
import { IResponseBody } from "../../Schemas/EndPoint";
import { GatewaySchema } from "../../Schemas/Gateway";

export interface GatewayCreateResponseBody extends IResponseBody {
  data: {
    payment_gateways: GatewaySchema;
  };
  errors: Array<any>
  message: string ; 
  success: boolean;
}

export interface GatewayCreateRequestBody {
  caption: string;
  url_secret_key: string;
  gateway_merchant_id: string;
  image_url: string;
  driver: string;
  api_url:string
  status: string;
  secret?:string
}

export class GatewayCreateRequest {
  private protectedAxiosInstance: AxiosInstance;
  private path = "/admin/payment-gateways";

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  async send(
    payload: GatewayCreateRequestBody
  ): Promise<GatewayCreateResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.path + "/create",
        payload
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
  async update(
    id: string,
    payload: GatewayCreateRequestBody
  ): Promise<GatewayCreateResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.path + `/${id}/update`,
        payload
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
